var _desc, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "logo",
    id: "logo-ispot",
    "aria-labelledby": titleId,
    role: "img",
    height: 40,
    width: 90,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 641.19 256.59",
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "logoTitle"
  }, "Link to iSpot Homepage") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "logoTitle"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "logoDesc"
  }, "Displays the iSpot logo and links to Link to the homepage")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo_dark"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    fill: "#ffffff",
    d: "M5.89,33.89c-7.7-7.6-7.9-20-.3-27.7l.3-.3c7.6-7.7,20-7.9,27.7-.3.1.1.2.2.3.3,7.7,7.6,7.9,20,.3,27.7-.1.1-.2.2-.3.3-7.6,7.7-20,7.9-27.7.3-.1-.2-.2-.2-.3-.3ZM35.29,212.49H3.89V63.49h31.4v149Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    fill: "#ffffff",
    d: "M126.89,43.89c-9.6,0-17.5,2-23.7,5.9s-9.2,9.8-9.2,17.8,3.1,14,9.2,18.2c6.2,4.2,19.3,8.7,39.3,13.6,20.1,4.9,35.2,11.7,45.4,20.4s15.3,21.7,15.3,38.8-6.4,30.9-19.3,41.6c-12.9,10.6-29.8,16-50.7,16-30.6,0-57.8-10.6-81.5-31.7l20.7-24.9c19.8,17.2,40.3,25.8,61.6,25.8,10.6,0,19.1-2.3,25.3-6.9,6.3-4.6,9.4-10.6,9.4-18.2s-2.9-13.4-8.8-17.6-16-8-30.4-11.5-25.3-6.6-32.8-9.5c-7.2-2.7-13.9-6.5-19.9-11.3-11.6-8.8-17.4-22.2-17.4-40.3s6.6-32.1,19.7-41.9c13.2-9.8,29.4-14.7,48.9-14.7,12.7,0,25.2,2.1,37.2,6.2,11.6,3.7,22.5,9.6,31.9,17.4l-17.6,24.9c-5.8-5.2-13.6-9.5-23.5-12.9-9.3-3.4-19.2-5.1-29.1-5.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    fill: "#ffffff",
    d: "M301.79,62.69c20,0,37.1,6.9,51.2,20.7,14.1,13.8,21.3,32.2,21.3,55.2s-7,41.6-21.1,56c-14.1,14.4-30.5,21.6-49.3,21.6s-35.6-8.2-50.5-24.6v65h-31.4V64.89h31.4v26c12.3-18.8,28.5-28.2,48.4-28.2ZM252.79,139.69c0,14.2,4.3,25.8,12.9,34.9,8,8.8,19.4,13.7,31.4,13.6,12.3,0,23-4.5,32.2-13.4s13.7-20.6,13.7-34.9-4.5-26.1-13.4-35.6c-9-9.4-19.7-14.1-32.2-14.1s-23,4.7-31.6,14.1c-8.6,9.4-13,21.2-13,35.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    fill: "#ffffff",
    d: "M587.69,90.09v75.6c0,7.1,1.9,12.7,5.6,16.9,3.7,4.2,9,6.3,15.7,6.3s13.2-3.3,19.3-9.8l12.9,22.1c-11,9.9-23.2,14.8-36.5,14.8-12.8.2-25.1-4.8-34.2-13.9-9.4-9.2-14.1-21.7-14.1-37.4V18.19h31.3v46.8h39.2v25.2l-39.2-.1Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    fill: "#4ac500",
    cx: 465.09,
    cy: 140.39,
    r: 76.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    fill: "#ffffff",
    d: "M454.79,101.09l-13.5-8.2c-3.9-2.3-7.8.6-7.8,4.6v86.1c-.2,2.8,2,5.2,4.8,5.3,1,.1,2-.2,2.9-.7,1.2-.7,6.5-3.9,13.7-8.3v-78.8h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    fill: "#ffffff",
    d: "M463.19,174.79l21.3-13v-42.5l-21.3-13v68.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    fill: "#ffffff",
    d: "M511.69,135.79l-18.7-11.4v32.2c9.8-6,17.5-10.7,18.7-11.5,2.6-1.6,3.4-5,1.7-7.6-.4-.7-1-1.2-1.7-1.7Z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.72a66a329bcd778c6836a941679f080a.svg";
export { ForwardRef as ReactComponent };